import Icon, { ColumnWidthOutlined, LineChartOutlined, RetweetOutlined, ToTopOutlined } from '@ant-design/icons';
import { Col, Row, Space } from 'antd';
import React from 'react';

import { BackCompressiveForceEstimationSVG } from '@/assets/icons/back-compressive-force-estimationSVG';
import { KimLhcIcon } from '@/assets/icons/ergonomic-tools/kim-lhc';
import { LibertyMutualReportIcon } from '@/assets/icons/LibertyMutualReportIcon';
import { NioshReportIcon } from '@/assets/icons/NioshReportIcon';
import { BodyChecklist } from '@/assets/svg/ergonomic_tools/owas/BodyChecklist';

import * as S from './styles';

export type Tool =
	| 'line'
	| 'toTop'
	| 'niosh'
	| 'liberty-mutual'
	| 'strain-index'
	| 'kim-mho'
	| 'kim-pp'
	| 'back-compressive-force-estimation'
	| 'owas'
	| 'kim-lhc';

interface ApplyToolProps {
	type: Tool;
	isActive: boolean;
	children: JSX.Element[];
	onClick: React.MouseEventHandler<HTMLElement>;
	fullWidth?: boolean;
}

const icons: Record<Tool, JSX.Element> = {
	line: <LineChartOutlined style={{ fontSize: 30 }} />,
	toTop: <ToTopOutlined style={{ fontSize: 30 }} />,
	niosh: <Icon component={NioshReportIcon} style={{ fontSize: 30 }} />,
	'liberty-mutual': <Icon component={LibertyMutualReportIcon} style={{ fontSize: 30 }} />,
	'strain-index': <RetweetOutlined style={{ fontSize: 30, color: 'black', marginRight: 8 }} />,
	'kim-mho': <ColumnWidthOutlined style={{ fontSize: 30, color: 'black', marginRight: 8 }} />,
	'kim-pp': <ColumnWidthOutlined style={{ fontSize: 30, color: 'black', marginRight: 8 }} />,
	'back-compressive-force-estimation': <BackCompressiveForceEstimationSVG size={'30'} color="black" />,
	owas: <BodyChecklist style={{ fontSize: 30, color: 'black', marginRight: 8 }} />,
	'kim-lhc': <KimLhcIcon style={{ width: 20, height: 20, color: 'black', marginRight: 8 }} />
};

export function ApplyTool({
	type = 'line',
	isActive = false,
	children = [],
	onClick,
	fullWidth = false
}: Readonly<ApplyToolProps>): JSX.Element {
	return (
		<S.Container hoverable onClick={onClick} $isActive={isActive} $fullWidth={fullWidth}>
			<Row align="middle" justify="center" gutter={[15, 0]}>
				<Col>{icons[type]}</Col>
				<Col>
					<Space direction="vertical" align="start">
						{React.Children.map(children, (child) => (
							<>{child}</>
						))}
					</Space>
				</Col>
			</Row>
		</S.Container>
	);
}
